import { styled } from 'styled-components'

import { resolveCssDimensionValue } from '../utilities/helpers'
import { Colors } from './colors'
import { FlexColumnContainer } from './CommonStyling'
import { PAGE_COMPONENT_GAP } from './constants'
import { Section } from './LayoutStyling'

/**
 * Section for form element grouping. Prefer using FormSectionContainer to layout children correctly or RegionWithLabel for region / landmark accessible with label
 */
export const FormSection = styled(Section)`
  padding: 0;

  & form > div {
    margin-bottom: 48px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  & form > hr {
    margin-bottom: 48px;
  }
`

export const FormSectionForTextInputs = styled.div`
  > div {
    margin-bottom: 30px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

export const IndentedFormFieldContainer = styled(FlexColumnContainer)<{ gap?: number | string }>`
  border-left: 1px solid ${Colors.BorderWeakNeutral};
  margin: 16px 0 0 10px;
  padding: 16px 0 24px 26px;
  gap: ${({ gap }) => resolveCssDimensionValue(gap, `${PAGE_COMPONENT_GAP}px`)};
`
